import React from 'react';
import { Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CKEditor } from 'ckeditor4-react';
import Spinner from '../../../spinner/spinner';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';
import apiError from '../../../../error';
import axios from '../../../../axios';
import { toast } from 'react-toastify';
import ImportAwarenessFromStore from '../../../create-template/pages/import-awareness-from-store';
import HtmlPreviewEditor from '../html-preview-editor';

export default class AwarenessPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "",
      awarenessPageName: "",
      customUrl: "",
      html: "",
      htmlKey: 1,
      showImportModal: false
    };
  }
  componentDidMount = () => {
    this.fetchawarenessPage();
    setTimeout(() => {
      this.setState({ htmlKey: this.state.htmlKey + 1 });
    }, 1500);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.campaignTemplateId !== this.props.campaignTemplateId) {
      this.fetchawarenessPage();
    }
  }

  handleModeChange = (e) => {
    this.setState({ mode: e.target.value });
  };

  handleAwarenessNameChange = (e) => {
    this.setState({ awarenessPageName: e.target.value });
  };

  handleCustomUrlChange = (e) => {
    this.setState({ customUrl: e.target.value });
  };

  handleEditorChange = (e) => {
    this.setState({ html: e.editor.getData() });
  };
  validate = () => {
    let data = {
      pageId: this.props.pageId,
      campaignTemplateId: this.props.campaignTemplateId,
      html: this.state.html,
    };
    if(!this.state.mode){
      toast.error("Please select an option");
      return false;
    }
    data.mode = this.state.mode;
    if (this.state.mode === 'custom-url' && !this.state.customUrl) {
      toast.error("Please enter a custom URL");
      return false;
    }
    if (this.state.mode === 'custom-url' && this.state.customUrl) {
      try {
        new URL(this.state.customUrl);
      } catch (_) {
        toast.error("Please enter a valid URL");
        return false;
      }
    }
    data.customUrl = this.state.customUrl;
    return data;
  }

  handleCreateAwareness = async () => {
    try {
      let validateData = this.validate();
      if (!validateData) return;
      this.setState({ loading: true });
      let response = await axios.post('/api/campaign/template/awareness-page', validateData);
      this.props.handleAwarenessPageId(response.data.id);
      toast.success("Awareness page created successfully");
      this.props.handleTabChange('next');
      this.setState({ loading: false });

      // this.setState({ htmlKey: this.state.htmlKey + 1 }); // Reset CKEditor
    } catch (error) {
      this.setState({ loading: false });
      apiError(error);
    }
  }
  fetchawarenessPage = async () => {
    try {
      if (!this.props.campaignTemplateId) {
        return;
      }
      const response = await axios.get('/api/campaign/template/awareness-page', {
        params: { campaignTemplateId: this.props.campaignTemplateId },
      });
      const { html, mode, url, id } = response.data;
      this.setState({
        html,
        mode,
        customUrl: mode === "custom-url" ? url : '',
        awarenessPageName: '',
        htmlKey: this.state.htmlKey + 1,
      });
      this.props.handleAwarenessPageId(id);
    } catch (error) {
      apiError(error);
    }
  }
  getHtml = () => this.state.html || "";
  applyGeneratedHtml = (html) => {
    if (!html) return;
    this.setState({
      html,
      mode: "editor",
      htmlKey: this.state.htmlKey + 1,
    });
  }

  handleLoadSelectedStoreTemplateHtml = (html, name) => {
    this.setState({
      html,
      htmlKey: this.state.htmlKey + 1,
    }, () => {
      toast.success(`Awareness page Loaded Successfully`);
    });
  }

  render() {
    const { mode, awarenessPageName, customUrl, html, htmlKey } = this.state;

    return (
      <>
        <div className="email-template-wrap">
          <div className='rightSectionHeader'>
            <div className="row justify-content-between align-items-center">
              <div className="col-md-3 tab-right-header">
                <h6>Awareness Page</h6>
                <p>Create Awareness Page</p>
              </div>
            </div>
          </div>
          <div className="awareness-page-create">
            <Form.Group className="filter-group awareness-page-mode-group mb-0">
              <Form.Label className="template-mode-label awareness-form-mode-label">Use Awareness Page Form</Form.Label>
              <div className="template-mode-options">
                <div className={`template-mode-option ${this.state.mode === "editor" ? "selected" : ""}`}>
                  <Form.Check
                    id="awareness-mode-editor"
                    type="radio"
                    label="Store"
                    name="powerOption1"
                    value="editor"
                    checked={this.state.mode === "editor"}
                    onChange={this.handleModeChange}
                  />
                </div>
                <div className="filter-separator-in" />
                <div className={`template-mode-option ${this.state.mode === "custom-url" ? "selected" : ""}`}>
                  <Form.Check
                    id="awareness-mode-custom-url"
                    type="radio"
                    label="Url"
                    name="powerOption1"
                    value="custom-url"
                    checked={this.state.mode === "custom-url"}
                    onChange={this.handleModeChange}
                  />
                </div>
              </div>
            </Form.Group>
          </div>

          {mode === 'custom-url' && (
            <Form.Group controlId="customUrl" className="mt-3">
              <Form.Label>Custom redirect URL</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter custom redirect URL"
                value={customUrl}
                onChange={this.handleCustomUrlChange}
              />
            </Form.Group>
          )}

          {mode === 'editor' && (
            <div className="mt-3">
              <div className="mb-3">
                <OverlayTrigger
                  placement='top'
                  overlay={<Tooltip id='top'>Import an awareness page from our template store</Tooltip>}>
                  <Button variant="secondary" type="button" onClick={() => this.setState({ showImportModal: true })} className="mr-2">Import From Store</Button>
                </OverlayTrigger>
              </div>
              <HtmlPreviewEditor
                label="Awareness Page"
                html={html}
                promptBar={this.props.promptBar}
              >
                <CKEditor
                  editorUrl={`${process.env.REACT_APP_API_URL}/staticpra/ckeditor/ckeditor.js`}
                  config={{
                    allowedContent: true,
                    fullPage: true,
                  }}
                  key={htmlKey}
                  initData={html}
                  onChange={this.handleEditorChange}
                />
              </HtmlPreviewEditor>
            </div>
          )}
        </div>
        <div className=" mt-2">
          <div className='footer-wrapper justify-content-end d-flex ft-padding'>
            <Button variant="secondary" className="btn closeBtn mr-2" onClick={e => this.props.handleTabChange('prev')}><ArrowBackOutlinedIcon className="btn-icon"></ArrowBackOutlinedIcon> Previous</Button>
            <Button variant="success" disabled={this.state.loading} type="button" onClick={this.handleCreateAwareness}><Spinner loading={this.state.loading}></Spinner><ArrowForwardOutlinedIcon className={this.state.loading ? "btn-icon d-none" : "btn-icon"}></ArrowForwardOutlinedIcon> Go To Next</Button>
          </div>
        </div>
        <ImportAwarenessFromStore
          showImportModal={this.state.showImportModal}
          handleClose={e => this.setState({ showImportModal: false })}
          handleLoadSelectedStoreTemplateHtml={this.handleLoadSelectedStoreTemplateHtml}
        ></ImportAwarenessFromStore>
      </>
    );
  }
}
